<template>
  <div class="box_ip">
    <div class="ip_center">
      <div class="aip">
        <div class="ip_left">
          <!---->
          <div
            class="ip_nav"
            v-for="(item, index) in navLs"
            :key="index"
            :style="index == ipIndex ? 'background-color:#bda67d;' : ''"
            @click="clickNavip(index)"
          >
            <div
              class="ip_div_1"
              :style="
                index == ipIndex
                  ? 'background-image:url(' +
                    require('../../../assets/images/zi_ico_1.png') +
                    '); border-bottom: 2px solid #bda67d;'
                  : 'background-image:url(' +
                    require('../../../assets/images/zi_ico_1.png') +
                    ');'
              "
            >
              <span>{{ item }} {{ lange == "ch" ? "期" : "stage" }}</span>
            </div>
          </div>
          <!---->
        </div>
        <div class="ip_right">
          <div class="ip_right_1">
            <!---->
            <div class="ip_rg_box" v-for="(item, index) in list" :key="index">
              <div class="ip_rg_cent">
                <div
                  class="ip_1"
                  :style="
                    'background-image:url(' +
                    require('../../../assets/images/zi_ico_2.png') +
                    ');'
                  "
                >
                  {{ item.num < 10 ? "0" + item.num : item.num }}
                </div>
                <div class="ip_2">
                  <div class="ip_2_1">
                    <span>{{
                      lange == "ch" ? item.cnTitle : item.enTitle
                    }}</span>
                  </div>
                </div>
                <div class="ip_3">
                 <div
                    class="ip_3_1"
                    v-if="isMobile()" v-html="lange == 'ch' ? removeHtmlStyle(item.cnDetail) : removeHtmlStyle(item.enDetail)">
                  </div>
                  <div
                    class="ip_3_1"
                    v-else="isMobile()" v-html="lange == 'ch' ? item.cnDetail : item.enDetail"
                  ></div>
                  <div class="ge"></div>
                  <div class="ip_3_2">
                    {{ lange == "ch" ? item.marker : item.enMarket }}
                  </div>
                </div>
                <div class="ip_4">
                  <span
                    >{{ item.n }}<small>{{ lange == "ch" ? "月" : "month" }}</small></span
                  >
                  <span
                    >{{ item.r < 10 ? "0" + item.r : item.r
                    }}<small>{{ lange == "ch" ? "日" : "day" }}</small></span
                  >
                </div>
                <router-link class="ip_5" :to="'/ipDetails?id=' + item.id"
                  ><img src="@/assets/images/zi_ico_3.png"
                /></router-link>
              </div>
            </div>
            <!---->
          </div>
          <div class="loading_box" v-if="loading">
            <i class="el-icon-loading"></i>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机端 左侧导航弹窗 -->
    <span class="biaodian" @click="clickRgl" v-if="showleft == false"
      ><img src="@/assets/images/zx_ico_3.png"
    /></span>
    <div class="nTcBox" v-if="showleft == true" @click="showclickHide">
      <div class="nTc" @click.stop="">
        <div
          class="ip_nav"
          v-for="(item, index) in navLs"
          :key="index"
          :style="index == ipIndex ? 'background-color:#bda67d;' : ''"
          @click.stop="clickNavip(index)"
        >
          <div
            class="ip_div_1"
            :style="
              index == ipIndex
                ? 'background-image:url(' +
                  require('../../../assets/images/zi_ico_1.png') +
                  '); border-bottom: 2px solid #bda67d;'
                : 'background-image:url(' +
                  require('../../../assets/images/zi_ico_1.png') +
                  ');'
            "
          >
            <span>{{ item }} {{ lange == "ch" ? "期" : "stage" }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ipclubList, ipNav } from "@/api/index";
export default {
  name: "Listx",
  components: {},
  data() {
    return {
      ipIndex: 0,
      lange: this.$cookies.getCookie("language"),
      navLs: [],
      showleft: false,
      list: [],
      bodyHeight: "",
      pageNum: 1,
      navPage: null,
      loading: false,
      listLoading:false,
    };
  },
  created() {
    var _this = this;
    this.$BackTop();
    this.$nextTick(() => {
      _this.listenerFunction(); //加载滚动事件
      _this.ipListFunc("", "", "初始化"); //加载列表
      _this.ipNavFunc(); //期刊导航
    });
  },
  beforeDestroy() {
    //移除监听滚动条事件
    document.removeEventListener("scroll", this.handleScroll, true); //  离开页面清除（移除）滚轮滚动事件
  },
  methods: {
    listenerFunction(e) {
      //监听滚动条事件
      document.addEventListener("scroll", this.handleScroll, true); // 监听（绑定）滚轮滚动事件
    },
    removeHtmlStyle (html) {
      let relStyle = /style\s*?=\s*?([‘"])[\s\S]*?\1/g; //去除样式
      let relTag = /<.+?>/g; //去除标签
      let relClass = /class\s*?=\s*?([‘"])[\s\S]*?\1/g;// 清除类名
      let newHtml = "";
      if (html) {
        newHtml = html.replace(relStyle, "");
        newHtml = newHtml.replace(relTag, '');
        newHtml = newHtml.replace(relClass, '');
      }
      return newHtml;
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    handleScroll() {
      //滚动距离
      var _this = this;
      // var bodyHeight = document.body.offsetHeight * 1 - window.innerHeight;
      var bodyHeight =
        document.body.offsetHeight * 1 - window.innerHeight - 150; //不需要一定完全触底.

      if (window.pageYOffset >= bodyHeight) {
        this.ipIndex = null;
        if (this.navPage != null) {
          this.list = [];
          this.pageNum = 0;
          this.navPage = null;
        }
        //_this.pageNum++;
        _this.ipListFunc(""); //列表
      }
    },
    clickNavip(index) {
      //滚动条滚到顶部
      // this.$BackTop();
      //导航点击
      this.ipIndex = index;
      this.navPage = index;
      this.ipListNavApi("", index * 1 + 1); //期刊列表api.pageNum
      this.showleft = false;
    },
    showclickHide() {
      this.showleft = false;
    },
    clickRgl() {
      if (this.showleft) {
        this.showleft = false;
      } else {
        this.showleft = true;
      }
    },
    ipListFunc(num, type) {
      //列表接口
      var _this = this;
      if(_this.listLoading){
        return ;
      }
      _this.listLoading = true;
      var ls = this.list;
      var pageNum = _this.pageNum++;
      var params = {
        num: num || "",
        pageNum: pageNum || 1,
      };
      //this.listenerFunction();

      ipclubList(params)
        .then((response) => {
          var arr = response.data.list;
          for (var i = 0; i < arr.length; i++) {
            arr[i].n = _this.timestampToTime(arr[i].showTime, "n");
            arr[i].r = _this.timestampToTime(arr[i].showTime, "r");
          }
          _this.list = ls.concat(arr);
          if (type != "初始化") {
            this.$nextTick(() => {
              document.body.scrollTop =
                document.body.offsetHeight * 1 - window.innerHeight * 1 - 1000;
              document.documentElement.scrollTop =
                document.body.offsetHeight * 1 - window.innerHeight * 1 - 1000;
            });
          }
          if(arr.length <  response.data.pageSize){
            _this.listLoading = true;
            document.removeEventListener("scroll", this.handleScroll, true); //  离开页面清除（移除）滚轮滚动事件
          }else{
            _this.listLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    ipListNavApi(num, pageNum) {
      //nav期刊导航 -- 列表接口
      var _this = this;
      var ls = this.list;
      this.loading = true;
      var params = {
        num: num || "",
        pageNum: pageNum || 1,
      };
      _this.listenerFunction();
      ipclubList(params)
        .then((response) => {
          _this.loading = false;
          var arr = response.data.list;
          for (var i = 0; i < arr.length; i++) {
            arr[i].n = this.timestampToTime(arr[i].showTime, "n");
            arr[i].r = this.timestampToTime(arr[i].showTime, "r");
          }
          this.list = arr;

          this.$nextTick(() => {
            document.body.scrollTop = 300;
            document.documentElement.scrollTop = 300;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    timestampToTime: function (timestamp, b) {
      //时间戳转换，日期
      var date = new Date(
        timestamp.toString().length < 13 ? timestamp * 1000 : timestamp * 1
      ); //时间戳为10位需*1000，时间戳为13位的话不需乘1000 用 乘以1
      var Y = date.getFullYear() + "";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "";
      var D = date.getDate() + "";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s = date.getSeconds();
      // return Y + M + D; //+h+m+s;
      if (b == "n") {
        return M;
      } else {
        return D;
      }
    },
    ipNavFunc() {
      //期刊导航
      ipNav()
        .then((response) => {
          var arr = response.data;
          var q = [];
          for (var i = 0; i < arr.length; i++) {
            q.push(arr[i][0] + "---" + arr[i][arr[i].length * 1 - 1]);
          }
          this.navLs = q;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  props: [],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box_ip {
  width: 100%;
  display: block;
}
.ip_center {
  width: 70.52%;
  display: block;
  margin: 0 auto;
}
.aip {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 70px 0;
}
.ip_left {
  width: 30%;
  display: block;
}
.ip_nav {
  width: 100%;
  display: block;
  cursor: pointer;
  box-sizing: border-box;
}
.ip_div_1 {
  width: 80%;
  display: block;
  border-bottom: 2px solid #e9e9eb;
  background-repeat: no-repeat;
  background-position: right center;
  background-size: 24px 23px;
  box-sizing: border-box;
}
.ip_div_1 > span {
  width: 80%;
  display: block;
  font-size: 18px;
  color: #02182c;
  font-weight: bold;
  line-height: 90px;
  margin: 0 10%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ip_right {
  width: 70%;
  display: block;
  border-left: 1px solid #e9e9eb;
  position: relative;
}
.ip_right_1 {
  width: 94%;
  display: block;
  margin-left: 6%;
}
/* 右侧 */
.ip_rg_box {
  width: 100%;
  display: block;
  margin: 0 0 60px 0;
}
.ip_rg_cent {
  width: 94%;
  display: block;
  margin: 20px 3%;
  background-color: #f6f6f6;
  border-radius: 14px;
  position: relative;
}
.ip_1 {
  width: 98px;
  height: 57px;
  display: block;
  position: absolute;
  top: -20px;
  left: -11px;
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 100% 100%;
  text-align: center;
  line-height: 54px;
  font-size: 20px;
  font-weight: bold;
  color: #4d4d4d;
}
.ip_2 {
  max-width: 70%;
  display: block;
  padding: 50px 0 20px 0;
}
.ip_2_1 {
  display: inline-block;
  background-color: #fff;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.ip_2_1 > span {
  display: block;
  padding: 10px 40px 10px 80px;
  font-size: 20px;
  color: #02182c;
  font-family: shsb,'Avenir', Helvetica, Arial, sans-serif;
}
.ip_3 {
  width: 70%;
  display: block;
  padding: 0 0 34px 10%;
}
.ip_3_1 {
  width: 100%;
  display: block;
  font-size: 14px;
  color: #7a7a7a;
  /*word-break: break-all;111*/
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}
.ge {
  width: 100%;
  height: 2px;
  display: block;
  background-color: #fff;
  margin: 20px 0;
}
.ip_3_2 {
  width: 100%;
  display: block;
  font-size: 14px;
  color: #bda67d;
  /*word-break: break-all;111*/
  font-family: shsb,'Avenir', Helvetica, Arial, sans-serif;
}
.ip_4 {
  max-width: 80px;
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  border-radius: 6px;
  border: 1px solid #d4c6ad;
  background-color: #fff;
  top: 46px;
  right: 5%;
}
.ip_4 > span {
  width: 100%;
  display: block;
  text-align: center;
  font-size: 18px;
}
.ip_4 > span:nth-child(1) {
  background-color: #d4c6ad;
  color: #fff;
}
.ip_4 > span:nth-child(2) {
  color: #7a7a7a;
}
.ip_5 {
  width: 60px;
  height: 60px;
  display: block;
  position: absolute;
  right: 5%;
  bottom: 10%;
  cursor: pointer;
}
.ip_5 > img {
  width: 100%;
  display: block;
}
.nTcBox {
  width: 100%;
  height: 100%;
  display: block;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.nTc {
  width: 220px;
  height: 100%;
  display: block;
  position: absolute;
  background-color: #fff;
  left: 0;
  top: 0;
  transition: 0.3s;
  overflow-y: scroll;
}
.biaodian {
  width: 40px;
  height: 40px;
  display: none;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  position: fixed;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  top: 44%;
  z-index: 20;
  transition: 0.3s;
  opacity: 0.8;
}
.biaodian > img {
  width: 50%;
  display: block;
  margin: 32% 0 0 25%;
}
.loading_box {
  width: 100%;
  height: 26px;
  display: block;
  position: absolute;
  bottom: -30px;
  text-align: center;
}
.loading_box > i {
  font-size: 26px;
  color: #aaa;
}
@media only screen and (max-width: 1440px) {
  .ip_center {
    width: 90%;
  }
}
@media only screen and (max-width: 600px) {
  .ip_left {
    display: none;
  }
  .ip_right {
    width: 100%;
    border-left: 0;
  }
  .ip_2_1 > span {
    padding: 10px 10px 10px 10px;
  }
  .ip_div_1 > span {
    line-height: 50px;
  }
  .ip_5 {
    width: 30px;
    height: 30px;
  }
  .ip_2 {
    max-width: 50%;
  }
  .biaodian {
    display: block;
  }
}
@media only screen and (max-width: 425px) {
  .ip_1 {
    width: 70px;
    height: 40px;
    font-size: 14px;
    line-height: 38px;
  }
  .ip_2 {
    padding: 30px 0 20px 0;
  }
  .ip_2_1 > span {
    font-size: 14px;
  }
  .ip_3_1 {
    font-size: 12px;
  }
  .ge {
    margin: 10px 0;
  }
  .ip_3_2 {
    font-size: 12px;
  }
  .aip {
    margin: 30px 0;
  }
  .ip_div_1 > span {
    font-size: 12px;
    line-height: 40px;
  }
  .ip_3{
        padding: 0 0 15px 10%;
  }
  .ip_4 {
    top: 25px;
  }
  .ip_4 > span {
    font-size: 12px;
    line-height: 22px;
  }
  .ip_div_1 {
    background-size: 24px 18px;
  }
  .ip_rg_box {
    margin: 0 0 40px 0;
  }
  .ip_5 > img {
    width: 75%;
    margin: 75% 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/IpPrivateClub/component/Listx.vue